import {useEffect, useState} from 'react'
import {PageLink, PageTitle} from '../../../../../../_metronic/layout/core'
import {KTCardBody} from '../../../../../../_metronic/helpers'
import {
  createDailyReward,
  getAllDailyRewards,
  updateDailyReward,
  deleteDailyReward,
} from '../../../../../../API/api-endpoint'
import ToastUtils, {ErrorToastUtils} from '../../../../../../utils/ToastUtils'
import SpinWheelReward from './SpinWheelReward'

const profileBreadCrumbs: Array<PageLink> = [
  {
    title: 'Daily Reward Plugin',
    path: 'plugin',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const DailyRewardPlugin = () => {
  const [dailyRewardList, setDailyRewardList] = useState<any>([])
  const [dailyReward, setDailyReward] = useState<any>({
    day: '',
    rewardType: 'coin',
    rewardValue: '',
  })
  const [isEdit, setIsEdit] = useState<any>(false)

  useEffect(() => {
    getRewardsList()
  }, [])

  const getRewardsList = async () => {
    let result = await getAllDailyRewards()
    console.log(result)
    if (result.success) {
      setDailyRewardList(result.data)
    } else {
      ErrorToastUtils(result.message)
    }
  }

  const createReward = async () => {
    let result = await createDailyReward(dailyReward)
    if (result.success) {
      resetForm()
      getRewardsList()
      ToastUtils({type: 'success', message: 'Daily Reward Created'})
    } else {
      ErrorToastUtils(result.message)
    }
  }

  const updateReward = async () => {
    let result = await updateDailyReward(dailyReward)
    if (result.success) {
      resetForm()
      getRewardsList()
      ToastUtils({type: 'success', message: 'Daily Reward Updated'})
    } else {
      ErrorToastUtils(result.message)
    }
  }

  const deleteReward = async (rewardId: any) => {
    let result = await deleteDailyReward(rewardId)
    if (result.success) {
      getRewardsList()
      ToastUtils({type: 'success', message: 'Daily Reward Deleted'})
    } else {
      ErrorToastUtils(result.message)
    }
  }

  const resetForm = () => {
    setDailyReward({day: '', rewardType: 'coin', rewardValue: ''})
    setIsEdit(false)
  }

  return (
    <>
      <PageTitle breadcrumbs={profileBreadCrumbs}>Daily Reward System</PageTitle>
      <div className='d-flex justify-content-end mb-4'>
        <button
          className='btn btn-primary'
          data-bs-toggle='modal'
          data-bs-target='#add_update_daily_reward'
          onClick={() => resetForm()}
        >
          Create
        </button>
      </div>
      <KTCardBody className='py-4 card'>
        <div className='table-responsive'>
          <table
            id='kt_table_users'
            className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'
          >
            <thead>
              <tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0'>
                <td>No.</td>
                <td>Day</td>
                <td>Type</td>
                <td>Value</td>
                <td>Action</td>
              </tr>
            </thead>
            <tbody className='text-gray-600 '>
              {dailyRewardList.length !== 0 &&
                dailyRewardList.map((reward: any, index: any) => {
                  return (
                    <tr key={index}>
                      <td>
                        <span>{index + 1}</span>
                      </td>
                      <td>
                        <span>Day {reward?.day || ' - '}</span>
                      </td>
                      <td>
                        <span className='text-capitalize'>{reward?.rewardType || ' - '}</span>
                      </td>
                      <td>
                        <span>
                          {reward?.rewardValue} {reward?.rewardType === 'coin' ? 'Coins' : 'Days'}
                        </span>
                      </td>
                      <td>
                        <div className='d-flex my-4'>
                          <button
                            className='btn btn-primary'
                            onClick={() => {
                              setDailyReward(reward)
                              setIsEdit(true)
                            }}
                            data-bs-toggle='modal'
                            data-bs-target='#add_update_daily_reward'
                          >
                            <i className='bi bi-pencil-square'></i>
                          </button>
                          &nbsp;
                          <button
                            className='btn btn-danger'
                            onClick={() => {
                              deleteReward(reward.dailyRewardId)
                            }}
                          >
                            <i className='bi bi-trash3'></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  )
                })}
            </tbody>
          </table>
        </div>
      </KTCardBody>

      <div className='mt-8'>
        <SpinWheelReward />
      </div>


      <div className='modal fade' tabIndex={-1} id='add_update_daily_reward'>
        <div className='modal-dialog'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h5 className='modal-title'>{isEdit ? 'Update' : 'Add'} Reward</h5>
              <div
                className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                data-bs-dismiss='modal'
                aria-label='Close'
                onClick={() => resetForm()}
              >
                <i className='fa-solid fa-xmark'></i>
              </div>
            </div>
            <div className='modal-body'>
              <label className='form-label fw-bold'>Day Number</label>
              <input
                placeholder='Enter Day Number'
                type='number'
                className={'form-control form-control-solid mb-3'}
                value={dailyReward.day}
                onChange={(e) =>
                  setDailyReward({
                    ...dailyReward,
                    day: e.target.value,
                  })
                }
              />

              <label className='form-label fw-bold'>Reward Type</label>
              <select
                className='form-select form-select-solid fw-bolder mb-3'
                value={dailyReward.rewardType}
                onChange={(e) =>
                  setDailyReward({
                    ...dailyReward,
                    rewardType: e.target.value,
                  })
                }
              >
                <option value='coin'>Coins</option>
                <option value='badge'>Badge</option>
              </select>

              <label className='form-label fw-bold'>
                {dailyReward.rewardType === 'coin' ? 'Coins Count' : 'Badge Days'}
              </label>
              <input
                placeholder={dailyReward.rewardType === 'coin' ? 'Enter Coins Count' : 'Enter Badge Days'}
                type='number'
                className={'form-control form-control-solid mb-3'}
                value={dailyReward.rewardValue}
                onChange={(e) =>
                  setDailyReward({
                    ...dailyReward,
                    rewardValue: e.target.value,
                  })
                }
              />
            </div>
            <div className='modal-footer'>
              <button
                type='button'
                className='btn btn-light'
                data-bs-dismiss='modal'
                onClick={() => resetForm()}
              >
                Close
              </button>

              <button
                type='button'
                className='btn btn-primary'
                data-bs-dismiss='modal'
                onClick={() => {
                  isEdit ? updateReward() : createReward()
                }}
              >
                {isEdit ? 'Update' : 'Add'} Reward
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default DailyRewardPlugin
